import { DateFormat } from "pcd_library";
import moment from 'moment';

export default class DateFormatter {
    static humanReadable(date: Date): string {
        return moment(date).format(DateFormat.HumanDisplay);
    }
}